<template>
    <div
        class="py-5 sm:py-6"
        data-spec-class="graph-skeleton"
    >
        <div class="grid animate-pulse grid-cols-24 gap-4">
            <div class="col-span-1 mt-auto">
                <div class="h-24 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-32 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-40 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-48 rounded-sm bg-muted" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-64 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-48 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-40 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-48 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-64 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-80 rounded-sm bg-muted" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-64 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-48 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-32 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-40 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-48 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-64 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-80 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-96 rounded-sm bg-muted" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-80 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-64 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-48 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-32 rounded-sm bg-secondary--inverse" />
            </div>
            <div class="col-span-1 mt-auto">
                <div class="h-24 rounded-sm bg-secondary--inverse" />
            </div>
        </div>
    </div>
</template>
